import Vue from "vue";
import Router from "vue-router";
// import index from '@/views/index/index'
import login from "@/views/login/login";
import aboutUs from "@/views/aboutUs/aboutUs";
import contact from "@/views/contact/contact";
import solution from "@/views/solution/index";
// import news from '@/views/news/news'
import anli from "@/views/anli/case";
import case1 from "@/views/anli/caseChild/case1";
import caseDetail from "@/views/anli/caseChild/caseDetail";
import case2 from "@/views/anli/caseChild/case2";
import newslist from "@/views/new/newslist";
import newslist1 from "@/views/new/newslist1";
import newinfos from "@/views/new/newinfos";
import productdetail from "@/views/product/detail";
import casedetail from "@/views/case/detail";

Vue.use(Router);

export default new Router({
  linkActiveClass: "active",
  linkExactActiveClass: "active",
  // 跳转返回顶部
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 };
    }
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/views/index/index"),
    },
    {
      path: "/login",
      name: "login",
      component: () => login,
    },
    {
      path: "/about",
      name: "aboutUs",
      component: aboutUs,
    },
    {
      path: "/solution",
      name: "solution",
      component: solution,
    },
    {
      path: "/contact",
      name: "contact",
      component: contact,
    },
    {
      path: "/productdetail",
      name: "ProductDetail",
      component: productdetail,
    },
    {
      path: "/casedetail",
      name: "Casedetail",
      component: casedetail,
    },
    {
      path: "/newslist1",
      name: newslist,
      component: newslist,
      children: [
        {
          path: "",
          name: newslist1,
          component: newslist1,
        },
        {
          path: "/newslist2",
          name: newslist1,
          component: newslist1,
        },
        {
          path: "/newslist3",
          name: newslist1,
          component: newslist1,
        },
        {
          path: "/newslist4",
          name: newslist1,
          component: newslist1,
        },
        {
          path: "/newslist1/newinfos",
          name: newinfos,
          component: newinfos,
        },
      ],
    },
  ],
});
// const originalReplace = Router.prototype.replace;
// Router.prototype.replace = function replace(location) {
//   return originalReplace.call(this, location).catch(err => err);
// };
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js